var t, e;
function s() {
  if (e) return t;
  e = 1;
  return t = class {
    constructor(t) {
      this.streetLine = t.street_line, this.secondary = t.secondary, this.city = t.city, this.state = t.state, this.zipcode = t.zipcode, this.entries = t.entries, t.source && (this.source = t.source);
    }
  };
}
export { s as __require };